export default {
  single: 'single',
  multi: 'multi',
  singleRequired: 'singleRequired',
  multiRequired: 'multiRequired',
} as const;
